up.CannotParse = class CannotParse extends up.Error {
};
